import React, { useState, useCallback, useEffect } from "react";
//import { FormError } from "../../FormError";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { setFromData } from "../../../slices/BusinessesSlice";
import { getBusinessFormData } from "../../../Utils/utils/CommanFnc";
import {MessageAlert} from "../MessageAlert"
export function BusinessNatue(props) {
  const [businessEntityNatures, setBusinessEntityNatures] = useState([]);
  //const formData = useSelector((state)=>state.businesses)
  let [enableKey, setEnableKey] = useState({"Goods":{}, "Services":{}})
  let [expoterEnableKey, setExpoterEnableKey] = useState({"Goods":false, "Services":false});
  const [dynamicVar, setDynamicVar] = useState({"GoodsParentDisabled": true, "ServicesParentDisabled": true})
  const [businessData, setBusinessData] = useState([])
  const [error, setError] = useState()
  const [time, setTime] = useState(null)
  const navigate = useNavigate() 
  const dispatch = useDispatch()
  const {
    register,
    handleSubmit,
    getValues,
    setValue
  } = useForm({
    mode: "onBlur"
  });
  let nature = []
  const modifieBusinessNature = useCallback(function(params){
    console.log("calling modifieBusinessNature")
    const businessNature = params?.businessEntityNature
    if(typeof businessNature === "undefined") return false;
    if(typeof businessEntityNatures !== "undefined" && Object.keys(businessEntityNatures).length > 0){
      let data = JSON.parse(JSON.stringify(businessEntityNatures))
      let index = 0
      let natureofbusiness = {}
      data.forEach((natureGroups)=>{
        natureGroups["natureGroups"].forEach((natures , gKey)=>{
          let natureGroupId = "";
          natures["nature"].forEach((nature)=>{
            if(businessNature.indexOf(nature.id) > -1){
              natureGroupId = natures["natureGroupId"]
              setValue(`businessEntityNature.${natureGroups.label}.${index}`,nature.id)
            }
            index++
          })
          if(natureGroupId){
            if(natures.isExpoter === "yes"){
              setValue(`natureofbusinessExpoter${natureGroups.label}`,natureGroupId)
              expoterEnableKey[`${natureGroups.label}`] = gKey
              setExpoterEnableKey(expoterEnableKey)
            }else{
              natureofbusiness[natureGroups.label] = natureGroupId.toString()
              //setValue(`natureofbusiness-${natureGroups.label}`,natureGroupId.toString())
              enableKey[natureGroups.label][natures.inputType] = gKey
            }
            dynamicVar[`${natureGroups.label}ParentDisabled`] = (natures.canExport === "yes"?false:true) 
          }
        })
      })
      setValue("natureofbusiness", natureofbusiness)
      setDynamicVar(dynamicVar)
      setEnableKey(() => {
        return enableKey
      })
      //setBusinessEntityNatures(data)
    }
  },[businessEntityNatures, dynamicVar, enableKey, expoterEnableKey, setValue])

  useEffect(()=>{
    setBusinessEntityNatures(props.businessNature)
  },[props.businessNature])

  useEffect(()=>{
    setBusinessData(getBusinessFormData());
  },[])

  useEffect( ()=>{
    if(typeof businessEntityNatures !== "undefined" && typeof businessData !== "undefined"){
      modifieBusinessNature(businessData)
    }

    if(time) clearTimeout(time)

    setTime(setTimeout(()=>{
      clearTimeout(time)
      if(typeof businessData?.businessEntity === "undefined"){
        navigate("/add-business/BusinessInformation")
      }
    },1000))

  },[businessData, businessEntityNatures])


  const selectHandler = async function(event, ...params){
    const {canExport, isExpoter, key, type, nature, isSingleSelect, inputType} = params[0]
    const selectedValues = getValues(`businessEntityNature.${type}`);
    const oppositeNature = (type === "Goods")?"Services":"Goods"
    const removeOppstNature = function(){
        const bEn = getValues(`businessEntityNature.${oppositeNature}`);
        let bEnNew = bEn.map((value, key, arr)=>{
            return arr[key] = false         
        })   
        setExpoterEnableKey((prevState) => {
          return {...prevState, ...{[oppositeNature]:false}};
        })
        setDynamicVar( (prevState) =>{
          return {...prevState, ...{[`${oppositeNature}ParentDisabled`]:false}};
        })
        setEnableKey( (prevState) =>{
          return {...prevState, ...{[oppositeNature]:false}};
        })
        setValue(`natureofbusinessExpoter${oppositeNature}`, false)
        setValue(`natureofbusiness.${oppositeNature}`,false)
        setValue(`businessEntityNature.${oppositeNature}`, bEnNew)
    }

    if(isSingleSelect === "yes"){
      removeOppstNature()
      //console.log(bEn)
    }else {
      let oppositeNatureValue = getValues(`natureofbusiness.${oppositeNature}`)
      let oppositeNatureGroups =  businessEntityNatures.find((item)=>item.label === oppositeNature)
      if(oppositeNatureValue){
        const oppsSelected = oppositeNatureGroups?.natureGroups?.find( (item) => item.natureGroupId.toString() === oppositeNatureValue[0])
        if(oppsSelected?.isSingleSelect === "yes"){
          removeOppstNature()
        }
      }
    }
    if(isExpoter === "no"){
      if(inputType !== "check"){
        for(let i = 0; i < selectedValues.length; i++){
          console.log(enableKey[`${type}`]['check'])
          if(i === enableKey[`${type}`]['check']){
            continue
          }
          selectedValues[i] = false
        }
      }
      enableKey[`${type}`][inputType] = event.target.checked?key:false
      console.log(type)
      setEnableKey({...enableKey, ...enableKey[`${type}`]})
      dynamicVar[`${type}ParentDisabled`]  = canExport === "yes"?false:true // disabled false 
      setDynamicVar(dynamicVar)
      expoterEnableKey[`${type}`] = false 
    }else{
      if(!event.target.checked){
        for(let i = 0; i < nature.length; i++){
          let index = selectedValues.indexOf(nature[i].id.toString() );
          if(index > -1){
            selectedValues[index] = false
          }
        }
      }
      expoterEnableKey[`${type}`] = event.target.checked?key:false
    }
    setExpoterEnableKey({...expoterEnableKey, ...expoterEnableKey[`${type}`]})
    setValue(`natureofbusinessExpoter${type}`, expoterEnableKey[`${type}`])
    setValue(`businessEntityNature.${type}`, selectedValues); 
  }

  const onSubmit = function(data){
    setError("");

    const businessEntityNature = data.businessEntityNature
    const businessEntity = {}
    const fil = []
    Object.keys(businessEntityNature).forEach( (item) =>{
      businessEntityNature[item].forEach( (val) => {
        if(val){
          fil.push(parseInt(val))
        }  
      } )
    })
    console.log(fil.length)
    if(fil.length === 0) {
      setError("Please select at least one Nature") 
      return
    }

    if(enableKey.Goods !== false && enableKey.Services !== false){
      businessEntity.typeOfSupplier = "both"
    }else if(enableKey.Goods === true){
      businessEntity.typeOfSupplier = "goods"
    }else if(enableKey.Services === true){
      businessEntity.typeOfSupplier = "services"
    }  

    Object.assign(businessEntity, businessData.businessEntity)
    
    businessEntity.deductorName = businessEntity.tradeName

    dispatch(setFromData({businessEntityNature:fil, businessEntity:businessEntity}))
    navigate("/add-business/BusinessRegistrationInfo")
  }

  const checkLoopInHalf = (innerIndex, cellDevide) => {
    
    let val = 1
    if(innerIndex === cellDevide){
       val=  1
       nature = []
    }else{ 
      val = innerIndex + 1
    }
    return val
  }

  let index = 0
  return (
    <React.Fragment>
      <form onSubmit={ handleSubmit(onSubmit) }>
        {
          (typeof businessEntityNatures !== "undefined")?
            (<div className="col-md-6 col-lg-12">
              <div className="card payment-card">
                <div className="card-body pt-0">
                  <div className="card-group">
                    {    
                      businessEntityNatures.map((item, key) => {
                        let innerIndex = 0
                        let cellDevide = Math.floor((item.natureGroups.length)/2)
                        nature = []
                        return (
                          <div className="col-sm-6" key={key}>
                            <div className="card">
                              <div className="card-header">
                                <h4 className="card-title">{item.label}</h4>
                              </div>
                              <hr />
                              <div className="card-body pt-0">
                                <div className="row">
                                    {
                                        item.natureGroups.map((natureGroup, nGKey)=>{
                                          innerIndex = checkLoopInHalf(innerIndex, cellDevide)
                                          let isDisabled = true
                                          // console.log(nGKey)
                                          // console.log(enableKey[`${item.label}`][natureGroup?.inputType])
                                            console.log(natureGroup.label,enableKey[`${item.label}`][natureGroup?.inputType] === nGKey)
                                          if(natureGroup.isExpoter === "yes" && expoterEnableKey[item.label] === nGKey){
                                            isDisabled = dynamicVar[`${item.label}ParentDisabled`]
                                          }
                                          if(enableKey[`${item.label}`][natureGroup?.inputType] === nGKey) {
                                            isDisabled = false
                                          }
                                          nature.push(
                                              <div className="col-12" key={nGKey}>                                     
                                                <ul className="list-group">
                                                  <li className="list-group-item outer-list-item">
                                                    <label className="pb-0">
                                                      {natureGroup.isExpoter === "yes"?<input
                                                        type={natureGroup?.inputType === "option"?"radio":"checkbox"}
                                                        value={natureGroup.natureGroupId}
                                                        {...register(`natureofbusinessExpoter${item.label}`)}
                                                        className="mr-2"
                                                        onChange={(e) => selectHandler(e, {...natureGroup, key:nGKey, type:item.label}) }
                                                        disabled={dynamicVar[`${item.label}ParentDisabled`]}
                                                      />:<input
                                                        type={natureGroup?.inputType === "option"?"radio":"checkbox"}
                                                        value={natureGroup.natureGroupId}
                                                        {...register(`natureofbusiness.${item.label}`)}
                                                        className="mr-2"
                                                        onChange={(e) => selectHandler(e, {...natureGroup, key:nGKey, type:item.label}) }
                                                      />}
                                                      {natureGroup.label}
                                                    </label>
                                                    {natureGroup?.nature?.length > 0 ?<ul>
                                                      {natureGroup.nature.map((nature, nKey)=>{
                                                        let ind = index++
                                                        return(
                                                          nature?.label?
                                                            <li key={nKey} className="inner-list-item mb-0">
                                                              <label className="pb-0">
                                                                <input
                                                                  type="checkbox"
                                                                  className="mr-2"
                                                                  //checked={checked?.[item.label]?.[ind] == nature.id?true:false}
                                                                  {...register(`businessEntityNature.${item.label}.${ind}`)}
                                                                  value={nature.id}
                                                                  disabled={isDisabled}/>
                                                                {nature.label}
                                                                
                                                              </label>
                                                            </li>:""
                                                        )
                                                      }
                                                      )
                                                      }
                                                    </ul>:""}
                                                  </li>
                                                </ul>
                                              </div>
                                          )
                                          return ((innerIndex === cellDevide)?<div key={nGKey} className="col-6">{nature}</div>:'' )
                                        })
                                    }
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
                </div>
                <div className="col-12 mb-3 text-right">
                  <NavLink
                    style={{"height":"38px", "lineHeight": "24px"}}
                    to="/add-business/BusinessInformation"
                    className={"btn btn-primary btn-lg px-5 m-3"}>
                  Prev
                  </NavLink>
                  <button
                    type="submit"
                    className="btn btn-success btn-lg px-5">
                  Next
                  </button>
                </div>
              </div>
            </div>
            ):""
        }
      </form> 
      {error && (<MessageAlert
        type={error?"error":""}
        message={error}
      />)}
      
    </React.Fragment>
  );
}
